module.exports = __webpack_public_path__ + "static/media/DataMgmt.e27c6bea.svg";